
export const domain = 'PaginationModel'

export const onClearState = `${domain}/onClearState`
export const onSetPageLastNext = `${domain}/onSetPageLastNext`
